import http from "../requestBase";

const API_BASE = "api/Live";

function clearSiteDataAll() {
    var queryString = `${API_BASE}/ClearSiteData/all`;
  return http.get(queryString);
}

function getVersion() {
    return http.get(`${API_BASE}/Version`);
}

export default {
    clearSiteDataAll,
    getVersion
};


// WEBPACK FOOTER //
// ./src/services/Live/index.js